require('angular').module('wowApp.common')
    .service('PopupWindowService', [require('./popup-window-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/popupwindowservice/index.js
 **/